import { Autocomplete, Box, FormHelperText, Grid, TextField, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Dropzone, RemoveContent } from '../../../../../shared/components/inputs'
import { useSelector } from 'react-redux'
import { IRootState } from '@/redux/types'

interface AddonsTabProps {
  novelty: any
  cover: string | null
  handleInputChange: (inputName: string, value: any) => void
}

export const AddonsTab = ({ novelty, cover, handleInputChange }: AddonsTabProps) => {
  const { t } = useTranslation(['global'])

  const { novelties } = useSelector((state: IRootState) => state.novelty)
  const { msgForm, errorForm } = useSelector((state: IRootState) => state.validator)

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Autocomplete
          id="combo-box-novelties"
          disableClearable
          value={novelty}
          options={novelties}
          onChange={(_event, value) => {
            handleInputChange('novelty', value)
          }}
          getOptionLabel={(option: any) => (option.id !== undefined ? option.title : '')}
          renderInput={params => <TextField {...params} label={t('novelty')} variant="filled" InputLabelProps={{ shrink: true }} />}
        />
      </Grid>

      <Grid item xs={12}>
        {cover ? (
          <Box my={2}>
            <RemoveContent
              files={[`${import.meta.env.VITE_AWS_URL}/seminars/${cover}`]}
              onHandleClick={() => handleInputChange('cover', null)}
            />
          </Box>
        ) : (
          <>
            <Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
              {`${t('cover')}:`}
            </Typography>
            <Dropzone name={'cover'} handleInputChange={handleInputChange} dir={'seminars'} />
            <FormHelperText error={errorForm.cover}>{msgForm.cover}</FormHelperText>
          </>
        )}
      </Grid>
    </Grid>
  )
}
